/* eslint-disable import/no-unresolved */

/* eslint-disable import/extensions */
import Promise from 'bluebird';
import { omit } from 'underscore';
import { getGridPreferences } from '@bingads-webui-campaign/summary-grid-helper';
import { TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import {
  convertStringToEnumForCampaign,
  convertStringToEnumForAdGroup,
} from '@bingads-webui-campaign-react/use-current-scope-entity';
import PageContext from '@bingads-webui-static-legacy/page-context';
import { getSegPreference, getSegType } from '@bingads-webui-component-legacy/bingads-grid/service/segmentation-preferences';
import segmentTimeChecker from '@bingads-webui-component-legacy/bingads-grid/shared/timeRangeChecker';
import { fetchPaginationConfig } from '@bingads-webui-component-legacy/bingads-grid/service/fetch-pagination';
import appState from '@bingads-webui-component-legacy/state/index';
import config from '@bingads-webui-component-legacy/config/index';

const pageContext = PageContext;

function getLegacyDependencies(contexts, getDeps) {
  if (!contexts.campaignContext) {
    return Promise.resolve(getDeps(contexts));
  }

  const {
    campaignContext: {
      currentCampaign,
      currentAdGroup,
    },
    scope: {
      values: {
        campaignId,
        adGroupId,
      },
    },
  } = contexts;
  const updatedProps = {};

  if (currentCampaign && campaignId) {
    updatedProps.currentCampaign = convertStringToEnumForCampaign(currentCampaign);
  }

  if (currentAdGroup && adGroupId) {
    updatedProps.currentAdGroup = convertStringToEnumForAdGroup(currentAdGroup);
  }

  // removed the dependency on app-legacy-bootstrap-webpack so assigning updated values to page context here.
  Object.assign(pageContext, { CurrentCampaign: updatedProps.currentCampaign, CurrentAdGroup: updatedProps.currentAdGroup });

  config.set({
    CurrentCampaign: updatedProps.currentCampaign,
  });

  return Promise.resolve(getDeps(contexts));
}

function fetchPreferenceConfig(gridName) {
  return new Promise((resolve) => {
    getGridPreferences({ // bluebird promise
      gridName, // should be the same as the grid config
      dateUtil: {
        format: value => TargetingSettingsContext.i18n.formatDate(value),
      },
      state: appState,
      getSegPreference,
      getSegType,
      segmentTimeChecker,
      fetchPaginationConfig,
    }).then((preferenceConfig) => {
      // eslint-disable-next-line no-param-reassign
      preferenceConfig.dataSource = omit(preferenceConfig.dataSource, 'query');
      resolve(preferenceConfig);
    });
  });
}

export function initializeWithLegacyDependencies(options, getDeps) {
  const {
    serverContext, scope, permissions, history, preferenceService,
  } = options;

  const campaignContext = (options.currentCampaign || options.currentAdGroup) ?
    {
      currentCampaign: options.currentCampaign,
      currentAdGroup: options.currentAdGroup,
    } : undefined;

  return getLegacyDependencies({
    serverContext, scope, permissions, campaignContext, history, preferenceService,
  }, getDeps).then((deps) => {
    TargetingSettingsContext.initialize(deps);
    TargetingSettingsContext.fetchPreferenceConfig = fetchPreferenceConfig;
    return deps;
  });
}

